export interface IPaidCardShippingDetailsFormRef {
  onSubmit: () => void;
  dirty: boolean;
}

export enum ECompanyCardResponseType {
  SUCCESS = "success",
}
